import { assign, createMachine, Interpreter, State } from 'xstate-v4'

export type ResetPasswordEvent =
  | { type: 'SUBMIT' }
  | { type: 'CHANGE_EMAIL'; value: string }

export interface ResetPasswordContext {
  errors?: Record<string, string[]>
  email: string
  next?: string
}

export function returnResetPasswordMachine() {
  return createMachine<ResetPasswordContext, ResetPasswordEvent>(
    {
      context: {
        email: '',
        next: '',
      },
      initial: 'idle',
      states: {
        idle: {
          initial: 'normal',
          on: {
            SUBMIT: 'resetting',
            CHANGE_EMAIL: {
              actions: assign({
                email: (_, { value }) => value,
              }),
              target: 'idle',
              internal: true,
            },
          },
          states: {
            normal: {
              onEntry: assign((_) => ({ errors: {} })),
            },
            errors: {},
          },
        },
        resetting: {
          invoke: {
            src: 'resetPassword',
            onDone: 'reset',
            onError: {
              actions: [
                'logError',
                assign({
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- TODO: Type XState event.data properly
                  errors: (_, { data }) => data,
                }),
              ],
              target: 'idle.errors',
            },
          },
        },
        reset: {
          type: 'final',
        },
      },
    },
    {
      actions: {
        logError: () => {
          throw new Error('resetPasswordMachine logError not implemented')
        },
      },
      services: {
        resetPassword: () => {
          throw new Error('resetPassword not implemented')
        },
      },
    },
  )
}

export type ResetPasswordService = Interpreter<
  ResetPasswordContext,
  any,
  ResetPasswordEvent
>

export type ResetPasswordStateType = State<
  ResetPasswordContext,
  ResetPasswordEvent
>
